module.exports = __webpack_public_path__ + "static/Maine detail 1-cdcff4cb4c525109f6e2a161c0e2f169.jpg";